interface ModuleId {
  RESTAURANT: string;
  MENU: string;
  CFD: string;
  KITCHEN: string;
  LS_ACCOUNTING: string;
}

export let moduleId: ModuleId = {
  RESTAURANT: 'restaurant',
  MENU: 'menu',
  CFD: 'customer_facing_display',
  KITCHEN: 'kitchen',
  LS_ACCOUNTING: 'lightspeed_accounting'
};
